const namespace = '[ENTITY_TICKETS]';

export const FETCH_TICKETS = `${namespace} FETCH_TICKETS`;
export const SET_TICKETS = `${namespace} SET_TICKETS`;
